import { Dialog, DialogContent, Grid, Typography } from '@material-ui/core';
import React from 'react'
import StyledButton from "../../models/Button";
import WarningIcon from "@material-ui/icons/Warning";
// import CloseIcon from "@material-ui/icons/Close";
// import StyledDialog from '../../../../../common/models/Dialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const SuccessFailedPopUp = (props) => {
  const { formFileSavedDialog, handlefileSavedDefault } = props;
  return (
    <React.Fragment>
      <Dialog
        open={formFileSavedDialog?.failure || formFileSavedDialog?.success || false}
        onClose={() => {
          handlefileSavedDefault();
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            {/* <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handlefileSavedDefault();
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography> */}
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              {formFileSavedDialog?.failure ?
                <WarningIcon
                  style={{
                    fontSize: "5rem",
                    color: "#F00",
                  }}
                /> : formFileSavedDialog?.success
                  ? <CheckCircleIcon style={{
                    fontSize: '5rem',
                    color: '#39811D',
                  }} /> :
                  <></>
              }


            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              flexDirection: 'column',
              justifyContent: "space-evenly", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              paddingBottom: '15px',
              paddingTop: '15px'
            }}
          >
            {formFileSavedDialog?.failure ? <><Typography style={{ textAlign: "center", fontSize: '23px', fontWeight: 500 }}>
              {formFileSavedDialog?.documentType === "artworkDoc" ? "Artwork Document" : "Form Number Document"} Upload Failed
            </Typography>
              <Typography style={{ textAlign: "center", paddingTop: '5px' }}>
                There was some error in the upload of {formFileSavedDialog?.documentType === "artworkDoc" ? "Artwork Document" : "Form Number Document"}. Please try again later.
              </Typography></>
              : formFileSavedDialog?.success ?
                <Typography style={{ textAlign: "center", fontSize: '23px', fontWeight: 500 }}>
                  {formFileSavedDialog?.documentType === "artworkDoc" ? "Artwork Document" : "Form Number Document"} Uploaded Successfully
                </Typography>
                : <Typography style={{ textAlign: "center" }}>
                  Something went wrong. Please try again.
                </Typography>
            }


          </div>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                handlefileSavedDefault();
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
      {/* <Dialog open={formFileSavedDialog?.success || false} onClose={() => handlefileSavedDefault()} fullWidth>
        <StyledDialog
          title={'Form Number Document Uploaded Successfully'}
          handleClose={() => handlefileSavedDefault(false)}
          hasMultipleButton={false}
        />
      </Dialog> */}
    </React.Fragment>
  )
}

export default SuccessFailedPopUp